import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Articles from './article/Articles';
import LocationValidator from './menu/LocationValidator';
import Menu from './menu/Menu';
import './App.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faTimes, faSyncAlt } from '@fortawesome/free-solid-svg-icons';

library.add(faBars, faTimes, faSyncAlt);

const App: React.FC<{}> = () => {
    return (
        <div className="app">
            <Menu/>
            <LocationValidator/>
            <Switch>
                <Route path="/" component={Articles}/>
            </Switch>
        </div>
    );
};

export default App;


// WEBPACK FOOTER //
// ./src/App.tsx